import {gql, useQuery} from '@apollo/client';
import type {PlanProviderSelectOption} from '../../../hooks/usePlanNamesProviders';
import type {mainPlanTypeType} from '../CreateBuilder/builderFields';
import type {BondSubplanProviderDentist} from '../../../schema-types/BondSubplanProviderDentist';

export const NO_SALTUS_GIA_GROSS_MESSAGE =
  'No Saltus GIA gross provider is available for this bond';

export const BOND_SUBPLAN_PROVIDER_DENTIST = gql`
  query BondSubplanProviderDentist {
    bondSubplanProviderDentist {
      id
      name
      formattedName
      showMandateSelector
    }
  }
`;

// A bond is saved as the adviser's wrapper plus one Saltus GIA gross subplan.
export const isBondPlan = (mainPlanType: mainPlanTypeType | undefined): boolean =>
  mainPlanType === 'bond';

// Undefined while loading, null when the backend has no bond subplan provider.
export const useBondSubplanProvider = (
  isBond: boolean
): PlanProviderSelectOption | null | undefined => {
  const {data, error} = useQuery<BondSubplanProviderDentist>(
    BOND_SUBPLAN_PROVIDER_DENTIST,
    {skip: !isBond}
  );
  if (!isBond) {
    return undefined;
  }
  if (error) {
    return null;
  }
  if (!data) {
    return undefined;
  }
  const provider = data.bondSubplanProviderDentist;
  if (!provider) {
    return null;
  }
  return {
    value: provider.id,
    label: provider.name || provider.formattedName || '',
    showMandateSelector: provider.showMandateSelector,
    isSaltus: true,
  };
};
